import React from "react";

export default function ProgressSteps({ currentStep }) {
  const totalSteps = 7;

  return (
    <div className="progress-wrapper">
      {[...Array(totalSteps)].map((_, i) => {
        const step = i + 1;
        const isCompleted = step < currentStep;
        const isActive = step === currentStep;

        return (
          <div className="progress-step-container" key={step}>
            {/* Line before step */}
            {step !== 1 && (
              <div
                className={`progress-line ${isCompleted ? "completed" : ""}`}
              ></div>
            )}

            {/* Step */}
            <div
              className={`progress-step
                ${isCompleted ? "completed" : ""}
                ${isActive ? "active" : ""}
              `}
            >
              {step}
            </div>

            {/* Line after step */}
            {step !== totalSteps && (
              <div
                className={`progress-line ${
                  step < currentStep ? "completed" : ""
                }`}
              ></div>
            )}
          </div>
        );
      })}
    </div>
  );
}
